import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {OphButtonModule} from '../../design/oph-button/oph-button.module';

@Component({
  selector: 'oph-skip-dialog-content',
  standalone: true,
  imports: [OphButtonModule],
  templateUrl: './oph-skip-dialog-content.component.html',
  styleUrl: './oph-skip-dialog-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OphSkipDialogContentComponent {
  // This component is used inside of a feature skip dialog as the dialog content
  message = input<string>();
  loading = input<boolean>();

  close = output<boolean>();
}
